import React, { Component } from 'react';
import { PaymentElement, ElementsConsumer } from '@stripe/react-stripe-js';
import { Stripe, StripeElements } from '@stripe/stripe-js';
import Card from '../components/Card'
import Heading from '../components/Heading'
import Logo from '../components/Logo'
import Row from '../components/Row/Row'
import CardButton from '../components/CardButton'
import alertService from '../services/alert.service'
import LoadingOverlay from '../components/LoadingOverlay/LoadingOverlay'
import { i18n } from "../i18n/i18n";

interface Props {
    stripe: Stripe | null;
    elements: StripeElements | null;
}

interface State {
  isLoading: boolean
}

class PaymentForm extends Component<Props, State> {

  initialState: State = {
    isLoading: false
  }

    constructor(props: Props) {
        super(props);
        this.state = this.initialState
        this.handleSubmit2 = this.handleSubmit2.bind(this)
    }

    async componentDidMount() {
    }

    handleSubmit2 = async () => {
      this.setState({isLoading: true})
      const {stripe, elements} = this.props;

      if (!stripe || !elements) {
        return;
      }

      const result = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: 'https://quandopro.com/paymentConfirmation',
        },
      })
      


      if (result.error) {
        alertService.warning(result.error.message ?? "Error processing payment. Please review your information and try again.");
        this.setState({isLoading: false})
      } else {
        //Redirect will happen
      }
    }

    render() {
      const { stripe } = this.props;
      if (!stripe) {
          return <div>Loading...</div>;
      }

      return (
        <Card className='mt-12'>
        {this.state.isLoading && <LoadingOverlay />}
        <div className='flex justify-between mb-5'>
          <div>
            <Heading
              text='Welcome to QPRO+'
              className='text-theme' />
            <div className="text-secondary">
              Fill out the form to request
              <br />
            </div>
          </div>
          <Logo type='icon' />
        </div>
        <Row column={2}>
            <PaymentElement />
        </Row>
        <Row column={2}>
          <CardButton
           proceedText={i18n("Pay now")}
            onProceedClick={this.handleSubmit2} />
          </Row>
      </Card>
      );
    }
}

export default function InjectedCheckoutForm() {
  return (
    <ElementsConsumer>
    {({stripe, elements}) => (
      <PaymentForm stripe={stripe} elements={elements} />
    )}
  </ElementsConsumer>
  )
}
